import { IStyle, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import React, { ReactNode } from 'react';

interface ClassNames {
    root: string;
    logo: string;
}

interface Props {
    logo: string;
    dimensions?: {
        width: number | string;
        height: number | string;
    }
    children?: ReactNode;
}

const getClassNames = memoizeFunction((logo: string, dim: NonNullable<Props['dimensions']>): ClassNames => {
    return mergeStyleSets({
        root: {
            display: 'flex',
            background: `linear-gradient(#E4E8ED, #fff)`,
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
        } as IStyle,
        logo: {
            background: `url(${logo}) no-repeat center center`,
            backgroundSize: 'contain',
            width: dim.width,
            height: dim.height,
            margin: '24px 0px 8px 0px',
        } as IStyle,
    });
});

const MainLogo: React.FC<Props> = ({ logo, dimensions = { width: '100%', height: 90 }, children }) => {
    const classNames = getClassNames(logo, dimensions);

    return (
        <div className={classNames.root}>
            <div className={classNames.logo} />
            {children}
        </div>
    );
};

export default MainLogo;
